import PropTypes from 'prop-types';
import { Component } from 'react';
// @ts-expect-error untyped module customer-data-objects-ui-components
import ObjectTypeIdType from 'customer-data-objects-ui-components/propTypes/ObjectTypeIdType';
import LogEventRowAction from 'automation-ui-action-features/components/LogEventRowAction';
import RotateObjectActionMetadata from 'automation-ui-action-features/actions/rotate-object/RotateObjectActionMetadata';
import RotateObjectActionDetail from 'automation-ui-action-features/actions/rotate-object/RotateObjectActionDetail';
import { jsx as _jsx } from "react/jsx-runtime";
class RotateObjectActionHistoryCard extends Component {
  render() {
    const {
      actionMetadata,
      flowObjectTypeId,
      actionLabel
    } = this.props;
    return /*#__PURE__*/_jsx(LogEventRowAction, {
      title: actionLabel,
      content: /*#__PURE__*/_jsx(RotateObjectActionDetail, {
        actionMetadata: actionMetadata,
        flowObjectTypeId: flowObjectTypeId
      })
    });
  }
}
RotateObjectActionHistoryCard.propTypes = {
  actionLabel: PropTypes.node,
  actionMetadata: PropTypes.instanceOf(RotateObjectActionMetadata).isRequired,
  flowObjectTypeId: ObjectTypeIdType
};
export default RotateObjectActionHistoryCard;